import { AuthError, signIn, signOut } from 'aws-amplify/auth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Environment } from 'src/const/constants';
import { PathRoutes } from 'src/const/Routes/PathRoutes';

interface UserLogin {
  username: string;
  password: string;
}

export const useUserLoginLogout = () => {
  const [error, setError] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async ({ username, password }: UserLogin) => {
    setError(undefined);
    setLoading(true);

    try {
      const result = await signIn({
        username: username.replace(/\s/g, ''),
        password,
        options: {
          // cognito-local only supports USER_PASSWORD_AUTH
          ...(process.env.REACT_APP_API_ENV === Environment.LOCAL && {
            authFlowType: 'USER_PASSWORD_AUTH',
          }),
        },
      });
      return { isSignedIn: !!result };
    } catch (e) {
      console.error('Login error:', e);
      if (e instanceof AuthError) {
        setError(e.message);
      } else {
        setError('Sorry, an unknown error occurred, please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    setLoading(true);
    try {
      await signOut();
      navigate(PathRoutes.RootRoute, { replace: true });
      navigate(0);
    } catch (error) {
      console.error('Error signing out', error);
      setError('Error signing out, please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    login,
    logout,
    error,
  };
};
